import React, { useCallback, useMemo } from "react";

import { IDepartureArrival } from "Bands/types";
import {
  CenteredText,
  Icon,
  MutedDarkText,
  BlackText,
  ExtraTinyText,
} from "shared/styles";
import { getTravelTime } from "shared/utils";
import { ArrowRight } from "shared/assets/icons";
import { colors } from "shared/styles/constants";
import { StyledLightTravelLegTeaser, StyledLightTravelTime } from "./styles";

interface Props {
  departure: IDepartureArrival;
  arrival: IDepartureArrival;
}

export const LightTravelLegTeaser: React.FC<Props> = ({
  departure,
  arrival,
}) => {
  const renderDepartureArrival = useCallback(
    ({ location }: Partial<IDepartureArrival>) => (
      <ExtraTinyText as={BlackText} style={{ overflowWrap: "anywhere" }}>
        <CenteredText>{location?.data.attributes.location}</CenteredText>
      </ExtraTinyText>
    ),
    []
  );

  const travelTime = useMemo(() => {
    if (!departure || !arrival) return;

    return (
      <StyledLightTravelTime>
        <CenteredText>
          <ExtraTinyText as={MutedDarkText}>
            {getTravelTime(departure, arrival)}
          </ExtraTinyText>
        </CenteredText>
        <Icon as={ArrowRight} color={colors.grey4} size="xs" />
      </StyledLightTravelTime>
    );
  }, [arrival, departure]);

  return (
    <StyledLightTravelLegTeaser>
      {departure && renderDepartureArrival(departure)}
      {travelTime}
      {arrival && renderDepartureArrival(arrival)}
    </StyledLightTravelLegTeaser>
  );
};
